import changelog from "../../../../../pages/personalbillett/docs/changelog-personnel-tickets.json5";
import * as React from 'react';
export default {
  changelog,
  React
};